import { slugQueryAtom } from '@store/appRouter/appRouter.atoms';
import { useAtom } from 'jotai';

export default function useQuestSlug() {
	return useAtom(slugQueryAtom);
}
